import get from 'lodash/get';
import qs from 'query-string';
import {
  thunkHandler,
  thunkErrorHanlder,
  parseUrl,
  Consequence,
  segmentTrackEvent,
  segmentIdentifyUser,
  segmentGroup
} from '../../libs/utils';
import {
  CLIENT_POLICY_CATALOG,
  CLIENT_AUTH,
  CLIENT_AUTH_MOBILE,
  CLIENT_RECEIPTS_RFC,
  CLIENT_RECEIPTS_CUSTOMER
} from '../../constants/endpoints';
import axios from 'axios';
import { downloadXls } from '../../libs/utils';
import runtimeConfig from '../../config/runtimeConfig';

export const CATALOG_POLICY = 'CATALOG_POLICY';
export const VALIDATE_TOKEN_CLIENT='VALIDA...IENT';
export const VALIDATE_TOKEN_CLIENT_MOBILE='VALIDA...BILE';
export const CLIENTS_RECEIPT_RFC = 'CLIENTS_RECEIPT_RFC';
export const CLIENTS_RECEIPT_CUSTOMER = 'CLIENTS_RECEIPT_CUSTOMER';
export const PERSIST_DATA_POLICY = 'PERSIST_DATA_POLICY';

// SEC-FIX: CLIENT_KEY movido a runtime config (config.js en servidor), fuera del bundle JS
const CLIENT_KEY = runtimeConfig.CLIENT_KEY;

export const validateTokenClient = () => {
  // SEC-FIX: leer CLIENT_KEY en el momento del request (no al cargar el módulo)
  const clientKey = runtimeConfig.CLIENT_KEY;
  const json = {
    tokenclient: CLIENT_KEY
  };
  return async dispatch => {
    try {
      const response = await axios.post(CLIENT_AUTH, json, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      dispatch({
        type: VALIDATE_TOKEN_CLIENT,
        payload: response.data
      });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
};

export const validateTokenClientMobile = (clientMobileToken) => {
  const json = {
    token: clientMobileToken,
    encrypt: true,
  };

  return async dispatch => {
    try {
      const response = await axios.post(CLIENT_AUTH_MOBILE, json, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      dispatch({
        type: VALIDATE_TOKEN_CLIENT_MOBILE,
        payload: response.data
      });
      return response.data;
    } catch (error) {
      console.log(error);
      dispatch({
        type: VALIDATE_TOKEN_CLIENT_MOBILE,
        payload: { error: (error.response && error.response.data) || error }
      });
      throw error;
    }
  };
};

export const getClientsCatalog = tokenz => {
  return async dispatch => {
    try {
      const customAxios = axios.create();

      const response = await customAxios.get(CLIENT_POLICY_CATALOG, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokenz}`
        }
      });
      dispatch({
        type: CATALOG_POLICY,
        payload: response.data
      });
    } catch (error) {
      console.error('Error in validateTokenCollection:', error);
    }
  };
};

export const getClientsRFC = (token, data, forceRefresh = false) => {
  return async dispatch => {
    try {
      const params = {
        policy_id: String(data.poliza).trim(),
        office_id: Number(data.oficina),
        product_id: Number(data.ramo),
        ...(data.rfc && { rfc: data.rfc }),
        ...(forceRefresh && { _t: Date.now() })
      };

      const customAxios = axios.create();
      const response = await customAxios.get(CLIENT_RECEIPTS_RFC, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0'
        },
        params: params
      });

      dispatch({
        type: CLIENTS_RECEIPT_RFC,
        payload: response.data
      });
    } catch (error) {
      console.error('Error in getClientsRFC:', error);
      throw error;
    }
  };
};

export const getCustomerRFC = (token, data) => {
  return async dispatch => {
    try {
      const params = {
        rfc: data.rfc,
        ...(data.customer_name 
          ? { customer_name: data.customer_name }
          : { company_name: data.company_name }),
        type: data.type,
        type_policy: data.type_policy,
      };

      const customAxios = axios.create();
      const response = await customAxios.get(CLIENT_RECEIPTS_CUSTOMER, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        params: params
      });
      dispatch({
        type: CLIENTS_RECEIPT_CUSTOMER,
        payload: response.data
      });
    } catch (error) {
      console.error('Error in getClientsRFC:', error);
      throw error;
    }
  };
};

export const persistDataPolicy = data => {
  return async dispatch => {
    dispatch({
      type: PERSIST_DATA_POLICY,
      payload: data
    });
  };
};

export const CLEAR_RECEIPTS = 'CLEAR_RECEIPTS';

export const clearReceipts = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_RECEIPTS,
      payload: null
    });
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/clientActions.js